import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Square: IconNode = [
  'svg',
  defaultAttributes,
  [['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }]],
];

export default Square;
